module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-btn-skew u-cursor-pointer",
    class: [_vm.selected ? 'is-selected' : ''],
    on: {
      "mouseenter": _vm._onMouseEvent,
      "click": _vm._onMouseClick
    }
  }, [_c('div', {
    staticClass: "c-btn-skew__container u-flex--y u-flex--align-items--stretch u-fit-w",
    class: {
      'c-btn-skew__bg--middle': _vm.num === 1
    }
  }, [_c('div', {
    staticClass: "c-btn-skew__bg u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-btn-skew__corner c-btn-skew__corner--tl u-absolute u-pos-tl"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-btn-skew__corner c-btn-skew__corner--br u-absolute u-pos-br"
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.$slots['logo']) ? _c('div', {
    staticClass: "c-btn-skew__logo u-absolute u-pos-tl u-fit u-flex--x u-pointer-none"
  }, [_vm._t("logo")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a17500"}!./src/scripts/components/app-btn-skew/template.html
// module id = 893
// module chunks = 0